'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
var index$1 = require('./index-c3c373ce.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
var paper = require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var enums$1 = require('./enums-097a7f7b.js');
var hqoTableBody = require('./hqo-table-body-6ed1171c.js');
var useTableContext_hook = require('./useTableContext.hook-ec1eae40.js');
var hqoTableEmptyState = require('./hqo-table-empty-state-d0d1118e.js');
var hqoTableFooter = require('./hqo-table-footer-49d0968e.js');
var hqoTableHeader = require('./hqo-table-header-78fdd5f6.js');
var hqoTableLoader = require('./hqo-table-loader-599fc56c.js');

var Table = styled__default(paper.Paper)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  min-height: 96px;\n  ", ";\n\n  &.version-2 {\n    background: transparent;\n    max-height: none;\n    margin-bottom: 48px;\n  }\n"], ["\n  position: relative;\n  min-height: 96px;\n  ", ";\n\n  &.version-2 {\n    background: transparent;\n    max-height: none;\n    margin-bottom: 48px;\n  }\n"])), function (_a) {
    var isResourceBookingTable = _a.isResourceBookingTable;
    return (isResourceBookingTable ? 'box-shadow: none' : 'max-height: 640px');
});
var HqOTable = function (_a) {
    var columns = _a.columns, _b = _a.footerType, footerType = _b === void 0 ? enums$1.FooterStyle.footerWithPagination : _b, _c = _a.headerType, headerType = _c === void 0 ? enums$1.HeaderStyle.headerWithSearch : _c, isLoading = _a.isLoading, isResourceBookingTable = _a.isResourceBookingTable, onRowClick = _a.onRowClick, _d = _a.version, version = _d === void 0 ? 1 : _d, props = tslib_es6.__rest(_a, ["columns", "footerType", "headerType", "isLoading", "isResourceBookingTable", "onRowClick", "version"]);
    var data = props.data, onSearch = props.onSearch, paginationProps = props.paginationProps, className = props.className;
    var tableContext = React.useMemo(function () { return ({
        data: data, methods: { onSearch: onSearch }, paginationProps: paginationProps, version: version,
    }); }, [data, onSearch, paginationProps, version]);
    var isFirstVersion = version === 1;
    return (React__default.createElement(Table, { borderRadius: isFirstVersion ? 'sm' : 'none', "data-testid": "hqo-table", "data-cy": "hqo-table", className: index$1.classnames("version-" + version, className), isResourceBookingTable: isResourceBookingTable, depth: isFirstVersion ? 1 : 'none' },
        React__default.createElement(useTableContext_hook.TableProvider, { value: tableContext },
            isFirstVersion && React__default.createElement(hqoTableHeader.HqOTableHeader, tslib_es6.__assign({}, props, { headerType: headerType })),
            React__default.createElement(hqoTableBody.HqOTableBody, tslib_es6.__assign({ columns: columns, isLoading: isFirstVersion && isLoading, isResourceBookingTable: isResourceBookingTable, onRowClick: onRowClick, version: version }, props)),
            React__default.createElement(hqoTableLoader.HqOTableLoader, { isLoading: isFirstVersion && isLoading, className: className }),
            React__default.createElement(hqoTableEmptyState.HqOTableEmptyState, tslib_es6.__assign({}, props, { isLoading: isLoading })),
            React__default.createElement(hqoTableFooter.HqOTableFooter, tslib_es6.__assign({}, props, { footerType: footerType })))));
};
var templateObject_1;

var types = /*#__PURE__*/Object.freeze({
  __proto__: null
});

exports.HqOTable = HqOTable;
exports.types = types;
